// Where to send a member after sign-in. `?next=` is only honoured when it is a
// same-origin relative path ("/dashboard?subpage=withdraw"): it must start with
// a single "/" (not "//" or "/\", which browsers treat as another host), carry
// no scheme and no control characters, and not point back at the login page.
export const DEFAULT_AFTER_LOGIN = '/dashboard';

export const safeNextPath = (raw, fallback = DEFAULT_AFTER_LOGIN) => {
  if (typeof raw !== 'string' || raw === '') return fallback;
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return fallback;
  // biome-ignore lint/suspicious/noControlCharactersInRegex: rejecting control characters is the point
  if (/[\u0000-\u001f\u007f\\]/.test(raw)) return fallback;
  if (/^\/[a-z][a-z0-9+.-]*:/i.test(raw)) return fallback;
  if (raw === '/login' || raw.startsWith('/login?') || raw.startsWith('/login/')) return fallback;
  return raw;
};

/** The `next` to put on a /login link for the page being left: its path and query. */
export const loginPathFor = (location) => {
  const here = `${location?.pathname || ''}${location?.search || ''}`;
  const next = safeNextPath(here, '');
  return next ? `/login?next=${encodeURIComponent(next)}` : '/login';
};
